import { dictionarySection } from "@/content/i18n/dictionaries";
import type { Locale } from "@/lib/i18n/config";

export type PressAsset = {
  label: string;
  href: string;
  kind: "logo" | "photo" | "document";
  description: string;
};

export type PressContent = {
  meta: {
    title: string;
    description: string;
    openGraphDescription: string;
    keywords: string[];
  };
  hero: {
    eyebrow: string;
    title: string;
    body: string;
  };
  boilerplate: {
    eyebrow: string;
    title: string;
    paragraphs: string[];
  };
  assets: {
    eyebrow: string;
    title: string;
    body: string;
    items: PressAsset[];
  };
  contact: {
    eyebrow: string;
    title: string;
    body: string;
    emailLabel: string;
    emailHref: string;
  };
};

export function getPress(locale: Locale): PressContent {
  return dictionarySection(locale, "press") as PressContent;
}
